import { render, staticRenderFns } from "./UList3C.vue?vue&type=template&id=541b2ae6&"
import script from "./UList3C.vue?vue&type=script&lang=js&"
export * from "./UList3C.vue?vue&type=script&lang=js&"
import style0 from "./UList3C.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports